import { isBool, isObj } from '../../utils';
import initialState from '../initialState';

const isValid = (navigation) => isObj(navigation) && isBool(navigation.isDrawerOpen);

const initState = (initialState) => {
  if (!isValid(initialState)) {
    throw Error('Invalid initial navigation state');
  }

  return {
    isDrawerOpen: initialState.isDrawerOpen,
  };
};

export const getters = {
  isDrawerOpen: ({ isDrawerOpen }) => isDrawerOpen,
};

const actions = {
  setDrawerOpen: ({ commit }, isOpen) => {
    commit('SET_DRAWER_OPEN', isOpen);
  },
  reset: ({ commit }) => commit('SET_DRAWER_OPEN', initialState.navigation.isDrawerOpen),
};

const mutations = {
  SET_DRAWER_OPEN(state, isOpen) {
    /* eslint-disable no-param-reassign */
    state.isDrawerOpen = isOpen;
  },
};

export default (initialState) => ({
  namespaced: true,
  state: initState(initialState),
  getters,
  actions,
  mutations,
});
